export default __webpack_public_path__ + "44f3c9afc471b036fff29e778175346f.png";